
import {
  Outlet,
  useLocation,
} from "react-router-dom";

import useRemoteAssets from "../utils/useRemoteAssets";

export default function DesktopLayout() {

  const location = useLocation();

  const isNotFoundPage =
    location.pathname === "/not-found";

  const isName =
    location.pathname === "/name";

  const isPassword =
    location.pathname === "/create-password";

  const success = location.pathname === "/success";

  const ASSETS = useRemoteAssets();

  if (!ASSETS) {
    return <div>Loading assets...</div>;
  }
  return (

    <div className="relative min-h-screen overflow-hidden bg-white">

      {/* Background Images */}

      <img
        src={ASSETS.bg1}
        className="absolute bottom-0 left-0 w-[10rem] pointer-events-none"
      />

      <img
        src={ASSETS.bg2}
        className="absolute top-[-2rem] right-[3vw] w-[clamp(120px,14vw,220px)] pointer-events-none"
      />

      <img
        src={ASSETS.bg3}
        className="absolute bottom-0 right-0 w-[clamp(60px,10vw,100px)] pointer-events-none"
      />

      {/* Main Layout */}

      <div
        className={`flex ${
          isNotFoundPage || success
            ? "items-center justify-center min-h-screen"
            : ""
        }`}
      >

        {/* Left Side Image */}

        {!isNotFoundPage && !success && (

          <img
            src={ASSETS.side}
            className="ml-[clamp(40px,10vw,180px)] mt-[clamp(80px,15vh,177px)] w-[clamp(300px,35vw,690px)]"
          />

        )}

        {/* Right Content */}

        <div
          className={`
            flex flex-col
            ${
              isNotFoundPage
                ? "items-center text-center"
                : ""
            }
            ml-[clamp(40px,8vw,120px)]
            mt-[clamp(80px,15vh,177px)]
          `}
        >

          {/* Logo Section */}

          <div
            className={`flex items-center gap-4 ${
              isNotFoundPage
                ? "justify-center"
                : ""
            }`}
          >

            <img
              src={ASSETS.logo}
              className="w-[clamp(60px,8vw,80px)]"
            />

            <div>

              <h1 className="text-[clamp(32px,5vw,64px)] leading-tight font-pattaya">

                Ambit Tech

              </h1>

              <p className="text-[clamp(12px,1.5vw,16px)]">

                Innovate. Integrate. Elevate.

              </p>

            </div>
          </div>

          {/* Page Content */}

          <div
            className={`
              mt-[clamp(60px,10vh,100px)]
              w-[clamp(300px,40vw,511px)]
              ${
                isNotFoundPage
                  ? "flex justify-center"
                  : ""
              }
            `}
          >

            <Outlet />

          </div>

          {/* Bottom Text */}

          {!isNotFoundPage &&
            !isName &&
            !isPassword &&
            !success && (

            <p className="mt-16 max-w-[22rem] md:max-w-[32rem] mx-auto text-[14px] md:text-[16px] leading-[22px] md:leading-[24px] font-medium text-black tracking-[-0.011em] text-center">

              Don't have a Login yet…!
              Just enter your Email ID
              and follow us.

              We ensure your Signup for
              a new account in few steps

            </p>

          )}

        </div>
      </div>
    </div>
  );
}